import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import http from "../services/httpServices";
import page from "../services/pageServices";
import InputIcon from "../components/form/elements/InputIcon";
import { loginPageColor, registerPageColor, registerPageIcon } from "../services/defaultSettings";
import {
    getFormData,
    handleFormErrors,
    handleFormSubmit,
    handleInputChange,
} from "../services/formServices";
import { useLocation, useNavigate } from "react-router-dom";

import modal from "../services/modalServices";
import SigningForm from "../components/form/singingForm/SigningForm";
import InputField from "../components/form/elements/InputField";

import registerPicture from "../assets/register.jpeg";

const StoreLocatorRequest = () => {
    const [governments, setGovernments] = useState([]);

    const [storeLocator, setStoreLocator] = useState({
        name: "",
        phone: "",
        address: "",
        wants_books: 0,
        wants_auto_insert_codes: 0,
        government_id: "",
        store_photo: "",
        national_id_copy: "",
    });
    const [errors, setErrors] = useState({});

    const [isLoading, setIsLoading] = useState(false);

    async function getGovernments() {
        const { data } = await http.get("/api/governments");
        setGovernments(data);
        storeLocator["government_id"] = data[0]["value"];
        setStoreLocator(storeLocator);
    }
    useEffect(() => {
        getGovernments();
        const currentTitle = page.getCurrentTitle();
        page.setTitle("طلب انشاء منفذ");
        return () => {
            page.setTitle(currentTitle);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let inputFields = [
        {
            id: "name",
            placeholder: `اسم المنفذ`,
            icon: <InputIcon icon="icon-park-solid:edit-name" />,
        },
        {
            id: "phone",
            placeholder: "رقم هاتف",
            icon: <InputIcon icon="ant-design:phone-filled" />,
            // className: "lg:col-span-2",
        },
        {
            id: "government_id",
            placeholder: "اختر محافظتك",
            type: "select",
            options: governments,

            className: "lg:col-span-2",
        },
        {
            id: "address",
            placeholder: "عنوان منفذك بالتفصيل",
            icon: <InputIcon icon="ant-design:phone-filled" />,
            className: "lg:col-span-2",
        },
    ];
    inputFields = [
        ...inputFields,
        {
            id: "wants_books",
            placeholder: "هل تريد بيع كتب ؟",
            icon: <InputIcon icon="bx:at" />,
            type: "switch",
        },
        {
            id: "wants_auto_insert_codes",
            placeholder: "هل تريد بيع اكواد ؟",
            icon: <InputIcon icon="bx:at" />,
            type: "switch",
        },
        {
            id: "store_photo",
            placeholder: "ارفق صورة للمنفذ",
            type: "file",
            icon: <InputIcon icon="icon-park-twotone:id-card" />,
        },
        {
            id: "national_id_copy",
            placeholder: "ارفع اثبات هوية شخصية / بطاقتك",
            type: "file",
            icon: <InputIcon icon="icon-park-twotone:id-card" />,
        },
    ];

    const handleSubmit = (e) => {
        handleFormSubmit(e, setIsLoading, setErrors, registerStoreLocator);
    };

    const navigate = useNavigate();

    const { state } = useLocation();

    const redirect = (certainPath = false) => {
        if (certainPath) {
            navigate(certainPath);
        } else {
            if (!state) {
                navigate("/home");
            } else {
                navigate(state.prevPath);
            }
        }
    };
    const registerStoreLocator = async () => {
        try {
            await http.get("/sanctum/csrf-cookie");
            const toSendStoreLocator = { ...storeLocator };
            toSendStoreLocator["phone"] = parseInt(storeLocator["phone"]);
            const formData = getFormData(toSendStoreLocator);

            const result = await http.post("api/store_locators_request", formData);
            setIsLoading(false);
            modal.message({
                title: `تم ادراج طلبك بنجاح !`,
                text: "طلب المنفذ الخاص بيك دلوقتي في حالة المراجعة من فريق الأستاذ وليد محسن و هيتم الرد عليك في خلال مدة اقصاها ٢٤ ساعة",
                callback: () => {
                    redirect("/home");
                },
            });
        } catch ({ response }) {
            handleFormErrors(response, setIsLoading, setErrors);
        }
    };

    return (
        <SigningForm
            className="space-y-6"
            headTitle={"طلب انشاء منفذ :"}
            headIcon={registerPageIcon}
            picture={registerPicture}
            description={
                "ادخل بيانات المنفذ بشكل صحيح وسيتم التواصل معك خلال ٢٤ ساعة لتأكيد طلبك !"
            }
            onSubmit={handleSubmit}
            fields={
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-6">
                    {inputFields.map((input, index) => {
                        return (
                            <InputField
                                key={index}
                                onChange={handleInputChange}
                                data={storeLocator}
                                setData={setStoreLocator}
                                errors={errors}
                                {...input}
                            />
                        );
                    })}
                </div>
            }
            color={registerPageColor}
            secondaryColor={loginPageColor}
            buttonTitle="طلب انشاء منفذ !"
            isLoading={isLoading}
        />
    );
};

export default StoreLocatorRequest;
